import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "i18n-fe";

// Card #3075 - the #698 Confirm Score dialog, pulled out of ScoringForm.jsx
// so its irreversible-warning copy and Cancel behavior can be rendered and
// tested on their own. The irreversible stage-1 gate: plain-language warning
// (freezes numbers one-way, releases the score to the announcer + FVD) before
// confirmMarks() runs. There is deliberately no matching "unconfirm" dialog
// or button anywhere.
export default function ConfirmScoreDialog({
  open,
  onClose,
  onConfirm,
  eliminated,
  eliminations,
  isConfirmingMarks,
}) {
  const { t } = useTranslation("score");
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        {eliminated ? "Confirm elimination?" : t("scoring.confirmScoreTitle")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {eliminated
            ? `This ride will be recorded as eliminated (${
                (eliminations ?? []).map((e) => e.reason).join("; ") ||
                "no reason given"
              }). This is permanent — the marks freeze and cannot be edited again. Comments can still be added until the sheet is signed.`
            : t("scoring.confirmScoreBody")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="inherit" disabled={isConfirmingMarks} onClick={onClose}>
          {t("scoring.confirmScoreCancel")}
        </Button>
        <Button
          variant="contained"
          color={eliminated ? "error" : "success"}
          disabled={isConfirmingMarks}
          onClick={onConfirm}
        >
          {eliminated ? "Confirm elimination" : t("scoring.confirmScoreConfirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
